Vue.component('ack-dream-team', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-dream-team',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-dream-team mounted');
		this.setPageIsLoading(false);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'dream-team-page',
			offices: [
				{
					title: 'Taiwan Headquarters',
					address: '11493, Taipei City, Neihu District, Section 1, Neihu Rd, No. 322, 6F',
					phone: '+(886) 2 7737 8330',
					email: 'sales@ackuretta.com marketing@ackuretta.com support@ackuretta.com',
				},
				{
					title: 'North America Office',
					address: '5900 Balcones Dr Ste 11647, Austin Texas 78731-4257',
					phone: null,
					email: 'northamerica.office@ackuretta.com',
				},
				{
					title: 'Europe Office',
					address: '166 Montée du Chemin Neuf, Montluel 01120 France',
					phone: '+(33) 640794082',
					email: 'europe.office@ackuretta.com',
				},
				{
					title: 'India Office',
					address:
						'85, Sheriff House, 2F, Richmond Rd, Richmond Town, Bengaluru, Karnataka 560025, India',
					phone: '+(91) 80 4008 7000',
					email: 'india.office@ackuretta.com',
				},
			],
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
